import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {IErrorRequest} from '../../models/error.interface';
import {select, Store} from '@ngrx/store';
import {IAppState} from '../../store/state/app.state';
import {selectCID, selectErrorPage} from '../../store/selectors/page.selectors';

@Component({
  selector: 'app-page-error',
  templateUrl: './page-error.component.html',
})
export class PageErrorComponent implements OnInit {


  // errorPage$: Observable<IErrorRequest>;
  pageCID$: Observable<string>;

  @Input() error: IErrorRequest;

  constructor(public _store: Store<IAppState>) {
    this.pageCID$ = this._store.pipe(select(selectCID));
    // this.errorPage$ = this._store.pipe(select(selectErrorPage));
    // this.errorPage$.subscribe((e) => {
    //   // console.log(e);
    // });
  }

  ngOnInit(): void {
  }

}
